function stackDelete(key){var data=this.__data__,result=data.delete(key);return this.size=data.size,result}module.exports=stackDelete;